import _ from "lodash";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

let endpoints = {
  registers: '/api/web/registrations',
  resendEmailConfirmation: '/api/web/registrations/resend-email-confirmation',
  forgotPassword: '/api/web/forgot-passwords',
  resetPassword: '/api/web/reset-passwords',
  users: '/api/web/users',
  sendVerifyEmail: '/api/web/users/send-verify-email',
  sessions: '/api/web/sessions',
  entraSession: '/api/web/sessions/entra',
  authMethods: '/api/web/sessions/auth-methods',
  checkEmailExists: '/api/web/users/check-email-exists',
  checkEmailExistsInProperty: '/api/web/users/check-email-exists-in-property',
  verifyEmail: '/api/web/verifications',
  properties: '/api/web/properties',
  propertyHosts: '/api/web/property-hosts',
  profiles: '/api/web/profiles',
  permissions: '/api/web/permissions',
  getUserPermission: '/api/web/permissions/get-user-permission',
  getUserOfProperty: '/api/web/property/get-user-of-property',
  primaryObjects: '/api/web/primary-objects',
  tasks: '/api/web/tasks',
  mobs: '/api/web/mobs',
  breeds: '/api/web/breeds',
  assets: '/api/web/assets',
  archiveAsset: '/api/web/assets/archive-asset',
  activities: '/api/web/activity-histories',
  feedingTypes: '/api/web/feeding-types',
  dashboard: '/api/web/dashboards',
  getActivityByProperty : '/api/web/activity-histories/get-livestock-history-by-property',
  getDataForBubbleChart : '/api/web/assets/get-data-for-bubble-chart',
  crops: '/api/web/crops',
  licences: '/api/web/licences',
  primaryObjectTypes: '/api/web/primary-object-types',
  qualifications: '/api/web/qualifications',
  pushnotification: "/api/web/push-notifications",
  emergencies: '/api/web/emergencies',
  facilities: '/api/web/facilities',
  serviceLogs: '/api/web/service-logs',
  defects: '/api/web/defects',
  workOrders: '/api/web/work-orders',
  inspections: '/api/web/inspections',
  inspectionChecklist: '/api/web/inspections/checklist',
  preStartTemplates: '/api/web/pre-start-templates',
  chemicalInventoryImport: '/api/web/facilities/import-chemical-inventory',
  subscriptions: '/api/web/subscriptions',
  applicationHistories: '/api/web/application-histories',
  images: "/api/web/images",
  weatherData: "/api/web/weather-datas",
  getDataForWeatherChart: "/api/web/weather-datas/get-data-for-weather-chart",
  getAnimalSire: "/api/web/facilities/get-animal-sire",
  getCategoryChart: "/api/web/facilities/get-category-chart",
  getDataTypePolicy: "/api/web/facilities/get-data-type-policy",
  forms: "/api/web/forms",
  getUserByProperty: "/api/web/users/get-user-by-property",
  splitMob: "/api/web/mobs/split-mob",
  userForm: "/api/web/user-forms",
  getHistoryByProperty: "/api/web/activity-histories/get-history-by-property",
  marketplaceProducts: "/api/web/marketplace-products",
  marketplaceCategories: "/api/web/marketplace-categories",
  getProductByCategory: "/api/web/marketplace-products/get-product-by-category",
  marketplaceCustomers: "/api/web/marketplace-customers",
  getAllProperties: "/api/web/properties/get-all-properties",
  getAllAssetsByProperty: "/api/web/assets/get-all-assets-by-property",
  getAllUsers: "/api/web/users/get-all-users",
  importFiles: "/api/web/import-files",
  mergeMob: "/api/web/mobs/merge-mob",
  archiveMob: "/api/web/mobs/archive-mob",
  getUserByRadius: "/api/web/users/get-user-by-radius",
  surveyQuestions: "/api/web/survey-questions",
  search: "/api/web/searches",
  surveyPending : "/api/web/users/get-user-survey-pending",
  layers: "/api/web/layers",
  layerObjects: "/api/web/layer-objects",
  attachments: "/api/web/attachments",
  attachmentFolders: "/api/web/attachment-folders",
  fileShares: "/api/web/file-shares",
  kmz: "/api/web/kmzs",
  calculatorPaddock: "/api/web/calculator-paddocks",
  optiWeight: "/api/web/opti-weights",
  activityPolicies:"/api/web/activity-policies",
  globalForms:"/api/web/global-forms",
  categoryGlobalForm:"/api/web/category-global-forms",
  subCategoryGlobalForm:"/api/web/sub-category-global-forms",
  device:"/api/web/devices",
  iotDevice:"/api/web/iot-devices",
  zoleoDevice:"/api/web/zoleo-devices",
  spotDevice:"/api/web/spot-devices",
  hmdDevice:"/api/web/hmd-devices",
  neyosDevice:"/api/web/neyos-devices",
  loraDevice:"/api/web/lora-devices",
  realpttDevice:"/api/web/real-ptt-devices",
  alertDevice:"/api/web/alert-devices",
  emergencyResponseProviders: "/api/web/emergency-response-providers",
  emergencyResponseTemplates: "/api/web/emergency-response-templates",
  healthSafety:"/api/web/health-safeties",
  agents:"/api/web/agents",
  observations: '/api/web/observations',
  visitorForm: '/api/web/visitor-forms',
  propertyCheckin: '/api/web/property-checkin',
  divisionContact: '/api/web/division-contact',
  visitor: '/api/web/visitors',
  workingRights: '/api/web/working-rights',
  weatherEmailSetting: '/api/web/weather-email-settings',
  addSAR: "/api/web/sars",
  getAllSARUser: "/api/web/users/get-all-users-for-sar",
  getAllSAR: "/api/web/sars",
  complateElapsed: "/api/web/sars/complate-elapsed",
  terminateAlarm: "/api/web/sars/terminate-alarm",
  publicForm: '/api/web/public-forms',
  introduction: '/api/web/introductions',
  getAllSensors: "/api/web/sensors/get-all-sensors",
  sensors: '/api/web/sensors',
  dynamoSensors: '/api/web/dynamo-sensors',
  paginatedProperties: '/api/web/paginated-properties',
  deviceSensors: '/api/web/device-sensors',
  senserTypeSettings: '/api/web/sensor-type-settings',
  incidents: '/api/web/incidents',
  incidentHistories: '/api/web/incident-histories',
  incidentActivities: '/api/web/incident-activities',
  incidentInvestigations: '/api/web/incident-investigations',
  incidentCorrectiveActions: '/api/web/incident-corrective-actions',
  incidentLessonsLearned: '/api/web/incident-lessons-learneds',
  // Shared user-location contract (Main, Team, Contractor and Web apps).
  location: '/api/web/locations',
  locationSharing: '/api/web/location-sharing',
  visitorInfo: '/api/web/visitor-infos',
  visitorInduction: '/api/web/visitor-inductions',
  // Which inductions a property requires (owner/admin configuration).
  propertyInductionRequirement: '/api/web/property-induction-requirements',
  sprayJobs: '/api/web/spray-jobs',
  V2PrimaryObjects: '/api/v2/primary-objects',
  spraySessions: '/api/web/spray-sessions',
  sprayJobTemplates: '/api/web/spray-job-templates',
  spraySettings: '/api/web/spray-settings',
  loraSensors: '/api/web/lora-sensors',
  corporateLoraDevices: '/api/web/corporate-lora-devices',
  trackpacSensors: '/api/web/trackpac-sensors',
  kineticSolutionsSensors: '/api/web/kinetic-solutions-sensors',
  adminUsers: '/api/web/admin-users',
  hazards: '/api/web/hazards',
  traccarSensors: '/api/web/traccar-sensors',
  alertDeviceNotification: '/api/web/api-alert-device-notifications',
  eroad: '/api/web/eroads',
  assetForm: '/api/web/asset-forms',
  sensorViews: '/api/web/sensor-views/index',
  sensorViewsCreate: '/api/web/sensor-views/create',
  mapViews: '/api/web/map-views/index',
  mapViewsCreate: '/api/web/map-views/create',
  approvals: '/api/web/approvals',
  propertySettings: '/api/web/property-settings',
  propertyHolidays: '/api/web/property-holidays',
  propertyRoles: '/api/web/property-roles',
  educationAssets: '/api/web/education-assets',
  educationSessions: '/api/web/education-sessions',
  training: '/api/web/training',
  contractors: '/api/web/contractors',
  contractorInsurance: '/api/web/contractor-insurance',
  contractorWorker: '/api/web/contractor-worker',
  contractorAsset: '/api/web/contractor-asset',
  contractorLicence: '/api/web/contractor-licence',
  contractorInduction: '/api/web/contractor-induction',
  contractorSafetyDocument: '/api/web/contractor-safety-document',
  propertyDivisions: '/api/web/property-divisions',
  propertySites: '/api/web/property-sites',
  corporateGroups: '/api/web/corporate-groups',
  corporateGroupEntraConfigs: '/api/web/corporate-group-entra-configs',
  divisions: '/api/web/divisions',
  divisionSites: '/api/web/division-sites',
  corporateReporting: '/api/web/corporate-reportings',
  propertySelect: '/api/web/property-select',
  mapAnnotations: '/api/web/map-annotations',
  annotationRoutes: '/api/web/annotation-routes',
  operationsPlans: '/api/web/operations-plans',
  operationsPlanDashboard: '/api/web/operations-plans/dashboard',
  operationsPlanItems: '/api/web/operations-plan-items',
  timeEntries: '/api/web/time-entries',
  timeEntryDashboard: '/api/web/time-entries/dashboard',
  timesheets: '/api/web/timesheets',
  timesheetApprove: '/api/web/timesheets/approve',
  timesheetApproveAll: '/api/web/timesheets/approve-all',
  shifts: '/api/web/shifts',
  workerList: '/api/web/worker-list',
  workerPaySettings: '/api/web/worker-pay-settings',
  operationsDashboard: '/api/web/operations-dashboards'
};
let API_ENDPOINTS = {};

_.forEach(
  endpoints,
  (value, key) => (API_ENDPOINTS[key] = `${API_BASE_URL}${value}`)
);
export const apiEndpoint = API_ENDPOINTS;

let API_ENDPOINTS_FUNCTION = {
  properties: (id) => {
    return API_BASE_URL + `${endpoints.properties}/${id}`;
  },
  primaryObjects: (id) => {
    return API_BASE_URL + `${endpoints.primaryObjects}/${id}`;
  },
  tasks: (id) => {
    return API_BASE_URL + `${endpoints.tasks}/${id}`;
  },
  mobs: (id) => {
    return API_BASE_URL + `${endpoints.mobs}/${id}`;
  },
  breeds: (id) => {
    return API_BASE_URL + `${endpoints.breeds}/${id}`;
  },
  profiles: (id) => {
    return API_BASE_URL + `${endpoints.profiles}/${id}`;
  },
  assets: (id) => {
    return API_BASE_URL + `${endpoints.assets}/${id}`;
  },
  activities: (id) => {
    return API_BASE_URL + `${endpoints.activities}/${id}`;
  },
  feedingTypes: (id) => {
    return API_BASE_URL + `${endpoints.feedingTypes}/${id}`;
  },
  crops: (id) => {
    return API_BASE_URL + `${endpoints.crops}/${id}`;
  },
  licences: (id) => {
    return API_BASE_URL + `${endpoints.licences}/${id}`;
  },
  primaryObjectTypes: (id) => {
    return API_BASE_URL + `${endpoints.primaryObjectTypes}/${id}`;
  },
  qualifications: (id) => {
    return API_BASE_URL + `${endpoints.qualifications}/${id}`;
  },
  emergencies: (id) => {
    return API_BASE_URL + `${endpoints.emergencies}/${id}`;
  },
  facilities: (id) => {
    return API_BASE_URL + `${endpoints.facilities}/${id}`;
  },
  serviceLogs: (id) => {
    return API_BASE_URL + `${endpoints.serviceLogs}/${id}`;
  },
  inspections: (id) => {
    return API_BASE_URL + `${endpoints.inspections}/${id}`;
  },
  inspectionEmail: (id) => {
    return API_BASE_URL + `${endpoints.inspections}/${id}/email`;
  },
  preStartTemplates: (id) => {
    return API_BASE_URL + `${endpoints.preStartTemplates}/${id}`;
  },
  permissions: (id) => {
    return API_BASE_URL + `${endpoints.permissions}/${id}`;
  },
  subscriptions: (id) => {
    return API_BASE_URL + `${endpoints.subscriptions}/${id}`;
  },
  applicationHistories: (id) => {
    return API_BASE_URL + `${endpoints.applicationHistories}/${id}`;
  },
  images: (id) => {
    return API_BASE_URL + `${endpoints.images}/${id}`;
  },
  weatherData: (id) => {
    return API_BASE_URL + `${endpoints.weatherData}/${id}`;
  },
  forms: (id) => {
    return API_BASE_URL + `${endpoints.forms}/${id}`;
  },
  userForm: (id) => {
    return API_BASE_URL + `${endpoints.userForm}/${id}`;
  },
  marketplaceProducts: (id) => {
    return API_BASE_URL + `${endpoints.marketplaceProducts}/${id}`;
  },
  marketplaceCategories: (id) => {
    return API_BASE_URL + `${endpoints.marketplaceCategories}/${id}`;
  },
  marketplaceCustomers: (id) => {
    return API_BASE_URL + `${endpoints.marketplaceCustomers}/${id}`;
  },
  surveyQuestions: (id) => {
    return API_BASE_URL + `${endpoints.surveyQuestions}/${id}`;
  },
  attachments: (id) => {
    return API_BASE_URL + `${endpoints.attachments}/${id}`;
  },
  attachmentFolders: (id) => {
    return API_BASE_URL + `${endpoints.attachmentFolders}/${id}`;
  },
  fileShareRevoke: (id) => {
    return API_BASE_URL + `${endpoints.fileShares}/${id}/revoke`;
  },
  fileShareDownload: (id) => {
    return API_BASE_URL + `${endpoints.fileShares}/${id}/download`;
  },
  calculatorPaddock: (id) => {
    return API_BASE_URL + `${endpoints.calculatorPaddock}/${id}`;
  },
  activityPolicies: (id) => {
    return API_BASE_URL + `${endpoints.activityPolicies}/${id}`;
  },
  layers: (id) => {
    return API_BASE_URL + `${endpoints.layers}/${id}`;
  },
  layerObjects: (id) => {
    return API_BASE_URL + `${endpoints.layerObjects}/${id}`;
  },  
  kmz: (id) => {
    return API_BASE_URL + `${endpoints.kmz}/${id}`;
  }, 
  optiWeight: (id) => {
    return API_BASE_URL + `${endpoints.optiWeight}/${id}`;
  }, 
  device: (id) => {
    return API_BASE_URL + `${endpoints.device}/${id}`;
  },
  iotDevice: (id) => {
    return API_BASE_URL + `${endpoints.iotDevice}/${id}`;
  },
  zoleoDevice: (id) => {
    return API_BASE_URL + `${endpoints.zoleoDevice}/${id}`;
  },
  spotDevice: (id) => {
    return API_BASE_URL + `${endpoints.spotDevice}/${id}`;
  },
  hmdDevice: (id) => {
    return API_BASE_URL + `${endpoints.hmdDevice}/${id}`;
  },
  neyosDevice: (id) => {
    return API_BASE_URL + `${endpoints.neyosDevice}/${id}`;
  },
  realpttDevice: (id) => {
    return API_BASE_URL + `${endpoints.realpttDevice}/${id}`;
  },
  loraDevice: (id) => {
    return API_BASE_URL + `${endpoints.loraDevice}/${id}`;
  },
  globalForms: (id) => {
    return API_BASE_URL + `${endpoints.globalForms}/${id}`;
  },
  categoryGlobalForm: (id) => {
    return API_BASE_URL + `${endpoints.categoryGlobalForm}/${id}`;
  },
  subCategoryGlobalForm: (id) => {
    return API_BASE_URL + `${endpoints.subCategoryGlobalForm}/${id}`;
  },
  pushnotification: (id) => {
    return API_BASE_URL + `${endpoints.pushnotification}/${id}`;
  },
  observations: (id) => {
    return API_BASE_URL + `${endpoints.observations}/${id}`;
  },
  visitors: (id) => {
    return API_BASE_URL + `${endpoints.visitor}/${id}`;
  },
  workingRights: (id) => {
    return API_BASE_URL + `${endpoints.workingRights}/${id}`;
  },
  agents: (id) => {
    return API_BASE_URL + `${endpoints.agents}/${id}`;
  },
  terminateSAR: (id) => {
    return API_BASE_URL + `${endpoints.getAllSAR}/${id}`;
  },
  getSARUser: (id) => {
    return API_BASE_URL + `${endpoints.getAllSARUser}/${id}`;
  },
  getAllSAR: (id) => {
    return API_BASE_URL + `${endpoints.getAllSAR}/${id}`;
  },
  sensors: (id) => {
    return API_BASE_URL + `${endpoints.sensors}/${id}`;
  },
  addSensorToAsset: () => {
    return API_BASE_URL + `${endpoints.sensors}/add-sensor-to-asset`;
  },
  removeSensorFromAsset: () => {
    return API_BASE_URL + `${endpoints.sensors}/remove-asset-sensor`;
  },
  getAssetSensors: (asset_id) => {
    return API_BASE_URL + `${endpoints.sensors}/get-asset-sensors?asset_id=${asset_id}`;
  },
  deviceSensors: (id) => {
    return API_BASE_URL + `${endpoints.deviceSensors}/${id}`;
  },
  deviceSensorDoorSummary: (id) => {
    return API_BASE_URL + `${endpoints.deviceSensors}/${id}/door-summary`;
  },
  senserTypeSettings: (id) => {
    return API_BASE_URL + `${endpoints.senserTypeSettings}/${id}`;
  },
  visitorInfo: (id) => {
    return API_BASE_URL + `${endpoints.visitorInfo}/${id}`;
  },
  sprayJobs: (id) => {
    return API_BASE_URL + `${endpoints.sprayJobs}/${id}`;
  },
  spraySessions: (id) => {
    return API_BASE_URL + `${endpoints.spraySessions}/${id}`;
  },
  hazards: (id) => {
    return API_BASE_URL + `${endpoints.hazards}/${id}`;
  },
  alertDeviceNotification: (id) => {
    return API_BASE_URL + `${endpoints.alertDeviceNotification}/${id}`;
  },
  assetForm: (id) => {
    return API_BASE_URL + `${endpoints.assetForm}/${id}`;
  },
  // Sensor View endpoints
  sensorViews: (id) => {
    return API_BASE_URL + `/api/web/sensor-views/view?id=${id}`;
  },
  sensorViewsUpdate: (id) => {
    return API_BASE_URL + `/api/web/sensor-views/update?id=${id}`;
  },
  sensorViewsDelete: (id) => {
    return API_BASE_URL + `/api/web/sensor-views/delete?id=${id}`;
  },
  sensorViewsGetSensors: (id) => {
    return API_BASE_URL + `/api/web/sensor-views/get-sensors?id=${id}`;
  },
  sensorViewsAddSensors: (id) => {
    return API_BASE_URL + `/api/web/sensor-views/add-sensors?id=${id}`;
  },
  sensorViewsRemoveSensors: (id) => {
    return API_BASE_URL + `/api/web/sensor-views/remove-sensors?id=${id}`;
  },
  mapViewsUpdate: (id) => {
    return API_BASE_URL + `/api/web/map-views/update?id=${id}`;
  },
  mapViewsDelete: (id) => {
    return API_BASE_URL + `/api/web/map-views/delete?id=${id}`;
  },
  mapViewsSetUserDefault: (id) => {
    return API_BASE_URL + `/api/web/map-views/set-user-default?id=${id}`;
  },
  mapViewsSetPropertyDefault: (id) => {
    return API_BASE_URL + `/api/web/map-views/set-property-default?id=${id}`;
  },
  mapViewsDeletePropertyDefault: (propertyId) => {
    return API_BASE_URL + `/api/web/map-views/delete-property-default?property_id=${propertyId}`;
  },
  mapViewsUpdatePropertyDefault: (id) => {
    return API_BASE_URL + `/api/web/map-views/update-property-default?id=${id}`;
  },
  approvals: (id) => {
    return API_BASE_URL + `${endpoints.approvals}/${id}`;
  },
  propertySettings: (id) => {
    return API_BASE_URL + `${endpoints.propertySettings}/${id}`;
  },
  propertyHolidays: (id) => {
    return API_BASE_URL + `${endpoints.propertyHolidays}/${id}`;
  },
  propertyRoles: (roleType = null) => {
    if (roleType) {
      return API_BASE_URL + `${endpoints.propertyRoles}/${roleType}`;
    }
    return API_BASE_URL + `${endpoints.propertyRoles}`;
  },
  educationAssets: (id) => {
    return API_BASE_URL + `${endpoints.educationAssets}/${id}`;
  },
  educationSessions: (id) => {
    return API_BASE_URL + `${endpoints.educationSessions}/${id}`;
  },
  propertyDivisions: (id) => {
    return API_BASE_URL + `${endpoints.propertyDivisions}/${id}`;
  },
  propertySites: (id) => {
    return API_BASE_URL + `${endpoints.propertySites}/${id}`;
  },
  corporateGroups: API_BASE_URL + endpoints.corporateGroups,
  corporateGroupEntraConfigs: (id) => API_BASE_URL + `${endpoints.corporateGroupEntraConfigs}/${id}`,
  divisions: API_BASE_URL + endpoints.divisions,
  divisionSites: API_BASE_URL + endpoints.divisionSites,
  mapAnnotations: (id) => API_BASE_URL + `${endpoints.mapAnnotations}/${id}`,
  annotationRoutes: (id) => API_BASE_URL + `${endpoints.annotationRoutes}/${id}`,
  operationsPlans: (id) => API_BASE_URL + `${endpoints.operationsPlans}/${id}`,
  operationsPlanItems: (id) => API_BASE_URL + `${endpoints.operationsPlanItems}/${id}`,
  timeEntries: (id) => API_BASE_URL + `${endpoints.timeEntries}/${id}`,
  shifts: (id) => API_BASE_URL + `${endpoints.shifts}/${id}`,
  workerList: (id) => API_BASE_URL + `${endpoints.workerList}/${id}`,
};

export const apiEndpointFunction = API_ENDPOINTS_FUNCTION;
